// Get all the size chart containers
const sizeChartContainers = document.querySelectorAll('.size-chart_container');

// Loop through each container to set up the event listeners
sizeChartContainers.forEach(container => {
  const sizeChartInButtons = container.querySelectorAll('.size-chart_in-button');
  const sizeChartCmButtons = container.querySelectorAll('.size-chart_cm-button');
  const sizeChartIns = container.querySelectorAll('.size-chart_in');
  const sizeChartCms = container.querySelectorAll('.size-chart_cm');

  sizeChartInButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      sizeChartIns[index].style.display = 'table-row-group';
      sizeChartCms[index].style.display = 'none';
      button.classList.add('size-chart_button-active');
      sizeChartCmButtons[index].classList.remove('size-chart_button-active');
    });
  });

  sizeChartCmButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      sizeChartCms[index].style.display = 'table-row-group';
      sizeChartIns[index].style.display = 'none';
      button.classList.add('size-chart_button-active');
      sizeChartInButtons[index].classList.remove('size-chart_button-active');
    });
  });
});


scrollDivs.forEach((scrollDiv) => {
  let isDown = false;
  let startX;
  let scrollLeft;

  scrollDiv.addEventListener('mousedown', (event) => {
    isDown = true;
    startX = event.pageX - scrollDiv.offsetLeft;
    scrollLeft = scrollDiv.scrollLeft;
  });

  scrollDiv.addEventListener('mouseleave', () => {
    isDown = false;
  });

  scrollDiv.addEventListener('mouseup', () => {
    isDown = false;
  });

  scrollDiv.addEventListener('mousemove', (event) => {
    if (!isDown) return;
    event.preventDefault();
    const x = event.pageX - scrollDiv.offsetLeft;
    const walk = (x - startX) * 1.5;
    scrollDiv.scrollLeft = scrollLeft - walk;
  });
});

// Select first size swatch on PDP
$(document).ready(function() {
    $('.option-selector--with-size-chart label.opt-label:first-of-type').click();
  });
